import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/scent-spray")({
  component: lazyRouteComponent(() => import("./-pages/admin.scent-spray")),
  head: () => ({ meta: [{ title: "بخّة العطر — Admin" }] }),
});
